import { createSlice } from "@reduxjs/toolkit";

const accountsSlice = createSlice({
  name: "accountReducer",
  initialState: {
    accountDetails: "",
    isLoading: false,
    myAccounts: [],
    accountHoldings: [],
    fromLogin: false,
  },
  reducers: {
    setIsLoading: (state, action) => {
      const { payload } = action;
      state.isLoading = payload;
    },
    setRedirectedFromLogin: (state, action) => {
      const { payload } = action;
      state.fromLogin = payload;
    },
    setAccountDetailsInfo: (state, action) => {
      const { payload } = action;
      state.accountDetails = payload;
    },
    setAccountsInfo: (state, action) => {
      const { payload } = action;
      state.myAccounts = payload;
    },
    setAccountHoldings: (state, action) => {
      const { payload } = action;
      state.accountHoldings = payload;
    },
  },
});

export const {
  actions: {
    setAccountsInfo,
    setIsLoading,
    setAccountDetailsInfo,
    setAccountHoldings,
    setRedirectedFromLogin,
  },
  reducer: accountReducer,
} = accountsSlice;
